exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".disclaimers{height:100%}.disclaimers__container{display:flex;flex-wrap:wrap;margin-top:1rem;height:calc(100% - 8rem)}.disclaimers__container>*,.disclaimers__control{width:100%}.disclaimers__wrapper :first-child{margin-top:0}.disclaimers__item .term{font-weight:700}.disclaimers__item .bar{color:#aaa;padding:0 10px}.disclaimers__item .link{color:#06a0df}.disclaimers__item .link:link,.disclaimers__item .link:visited{text-decoration:none}.disclaimers__item .link:active,.disclaimers__item .link:focus,.disclaimers__item .link:hover{text-decoration:underline}.disclaimers__item--italic{font-style:italic}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-d244f0a8!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Disclaimers.vue
// module id = 283
// module chunks = 0